import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AuthenticationService } from "./authentication.service";
import moment from "moment/moment";
import { ICurrentUser } from "../models/user-interface";
import { INotificationCategory } from "../models/notification";

@Injectable({
  providedIn: "root",
})
export class CommunicationsService {
  public list: any = [];

  public categoriesList: any = [];

  public baseUrl: string = "/notification";

  public baseUrlCategories: string = "/notification-category";

  public statusList: Array<string> = ["In coda", "Errore", "Completato", "Invio in corso"];

  public currentUser: ICurrentUser;

  public newNotificationNumber: number = 0;

  public today: any = moment().format("YYYY-MM-DD HH:mm:ss");

  public myNotifications: any[] = [];

  public myNotificationsLoaded: boolean = false;

  public myNotificationOld: any[] = [];

  public myNotificationOldLoaded: boolean = false;

  constructor(
    public _httpClient: HttpClient,
    public _authenticationService: AuthenticationService,
  ) {
    this.currentUser = _authenticationService.getCurrentUser();
  }

  async getList(defRet: any = []): Promise<any> {
    if (this.currentUser.send_onboarding === 0) {
      return (this.list = []);
    }
    return this._httpClient
      .get(this.baseUrl)
      .toPromise()
      .then((response) => {
        this.list = response;
        return response;
      })
      .catch((err) => {
        console.error(err);
        return defRet;
      });
  }

  async getMine() {
    return this._httpClient
      .get("/me/notification")
      .toPromise()
      .then((notifications: any[]) => {
        this.myNotifications = notifications;
        this.newNotificationNumber = notifications.length;
        this.myNotificationsLoaded = true;
        return notifications;
      });
  }

  async getMineOld() {
    return this._httpClient
      .get("/me/notification?read=1")
      .toPromise()
      .then((notifications: any[]) => {
        this.myNotificationOldLoaded = true;
        this.myNotificationOld = notifications;
        return notifications;
      });
  }

  async getCommunication(id: number) {
    return this._httpClient.get(this.baseUrl + "/" + id).toPromise();
  }

  async delete(id: number) {
    return this._httpClient
      .delete(this.baseUrl + "/" + id)
      .toPromise()
      .then(async (response) => {
        await this.getList();
        this.list = response;
        return response;
      });
  }

  async create(data: any = []) {
    return this._httpClient
      .post(this.baseUrl, data)
      .toPromise();
  }

  async update(id: number, data: any = {}) {
    return this._httpClient
      .put(this.baseUrl + "/" + id, data)
      .toPromise()
      .then(async () => {
        await this.getList();
      });
  }

  async setRead(notifications: any = []) {
    return this._httpClient
      .post(this.baseUrl + "/set-read", { notifications })
      .toPromise()
      .then(async () => {
        await this.getMine();
        await this.getMineOld();
      });
  }

  async getListCategories() {
    return this._httpClient
      .get(this.baseUrlCategories)
      .toPromise()
      .then((response: INotificationCategory[]) => {
        this.categoriesList = response;
        return response;
      });
  }

  async deleteCategories(id: number) {
    return this._httpClient
      .delete(this.baseUrlCategories + "/" + id)
      .toPromise()
      .then(async (response) => {
        await this.getList();
        this.categoriesList = response;
        return response;
      });
  }

  async createCategories(data: any = {}) {
    return this._httpClient
      .post(this.baseUrlCategories, data)
      .toPromise()
      .then(async (response) => {
        await this.getList();
        return response;
      });
  }

  async updateCategories(id: number, data: any = {}) {
    return this._httpClient.put(this.baseUrlCategories + "/" + id, data).toPromise();
    // commentato il then altrimenti sovrascrive la chiamata della lista e al modifica della categoria ci mette 1 minuto
    // .then(async () => {
    //     await this.getList();
    // })
  }
}
